<template>  
  <div id="overlay" v-on:click="modal"></div>
	<section>
    <div class='container-fluid'>
		  <div class='row flex-nowrap'>
        <div class='col-auto d-none d-md-block col-md-1 col-xl-1  px-0 px-sm-10' id='menu-page' style='background: #2d648b; border-right: 2px solid #06a6cf0d;'>
          <div class='d-flex flex-column align-items-center align-items-sm-start text-white min-vh-100'>

            <router-link to='../' title='My Shortcut' style="align-self: center;" class="d-none d-xl-block">
              <img src='./assets/images/homeloan-logo.png' alt='Home Shortcut Logo'>
            </router-link>

            <nav id="menu" style="width: 100%;">
              <!--<router-link :to="{ name: 'home' }" class="text-center"><div class="leads navLink"><span class='d-none d-xl-block'>Opportunities</span></div></router-link>-->
              <router-link :to="{ name: 'accountList' }" class="text-center"><div class=" navLink home" ><span class='d-none d-xl-block'>Home Loans</span></div></router-link>
              <router-link :to="{ name: 'borrowerList' }" class="text-center"><div class="users navLink"><span class='d-none d-xl-block'>Customers</span></div></router-link>
              <router-link :to="{ name: 'tasks' }" class="text-center"><div class="tasks navLink"><span class='d-none d-xl-block'>Tasks</span></div></router-link>
              <!--<router-link :to="{ name: 'portfolio' }" class="text-center"><div class="chart navLink"><span class='d-none d-xl-block'>Portfolio</span></router-link>-->
              <router-link :to="{ name: 'portfolioReport' }" class="text-center"><div class="chart navLink"><span class='d-none d-xl-block'>Portfolio</span></div></router-link>  
              <router-link :to="{ name: 'portfolioLender' }" class="text-center"><div class="chart navLink"><span class='d-none d-xl-block'>Lenders</span></div></router-link>             
              <!--<router-link :to="{ name: 'compare' }" class="text-center"><div class="search navLink"><span class='d-none d-xl-block'><br>Compare Products</span></div></router-link>-->
              <router-link :to="{ name: 'calculators' }" class="text-center"><div class="calculator navLink"><span class='d-none d-xl-block'>Calculators</span></div></router-link>
              <!--<router-link :to="{ name: 'blogList' }" class="text-center"><div class="blognavLink"><span class='d-none d-xl-block'>Blog</span></div></router-link>-->
              <router-link :to="{ name: 'upload' }" class="text-center"><div class='upload navLink'><span class='d-none d-xl-block'>File Upload</span></div></router-link>
              <router-link :to="{ name: 'rateRoll' }" class="text-center"><div class='upload navLink'><span class='d-none d-xl-block'>Rate Roll</span></div></router-link>
            </nav>
          </div>
        </div>

        <!-- Mobile -->
        <div class='navbar d-block d-md-none' id='mobileMenu'>
          <div class='col-4' style='border-right: thin solid #fff;'><router-link :to="{ name: 'accountList' }" class="text-center home">Home Loans</router-link></div>
          <div class='col-4' style='border-right: thin solid #fff;'><router-link :to="{ name: 'tasks' }" class="text-center tasks">Tasks</router-link></div>
          <div class='col-4' style='border-right: thin solid #fff;'><router-link :to="{ name: 'calculators' }" class="text-center calculator">Calculators</router-link></div>
        </div> 

        <div class="col-auto col-md-11 col-xl-11">
          <div class='row'>
            <div class="col-12">					
	            <div class='page-section' style="min-height: 5vh; padding: 10px;">										
                <div class='row'>
                  <div class='col-2 col-md-2 col-xl-2'>
                    <a class='btn btn-primary' @click="$router.go(-1)">Back</a>
                  </div>
                  <div class="d-none d-md-block col-md-3 col-xl-6" style="margin: auto 0px; font-family: Raleway; font-size: 24px;">
                    Welcome {{ name }}  
                  </div>
                  <div class='col-7 col-md-5 col-xl-3 text-end' style="margin: auto 0px;">
                    <router-link to='../' :title='group'>
                      <img v-if="logo" :src="'data:image/png;base64,'+logo" :alt="group" style="padding: 0px 20px;" />
                    </router-link>
                    <router-link :to="{ name: 'settings' }" class="text-center" title="Broker Settings"><span class='cog'></span></router-link>
                  </div>
                  <div class="col-3 col-md-2 col-xl-1 text-end">
                    <span class="btn btn-action" v-on:click="logout()" style="border-radius: 6px; height: 46px; width: 80px; align-content: center; text-align: center;">Logout</span>
                  </div>
                </div>
              </div> 
            </div>
          </div>

          <div class="col-12">
            <router-view />
          </div>
        </div>
        
      </div>
    </div>
  </section>
  <FooterPage />
</template>



<script setup>
  import FooterPage from './components/FooterPage.vue'
  import { useRouter } from 'vue-router'
  import { inject } from 'vue'
  
  const name = inject('Name')
  const group = inject('Group')
  const logo = inject('Logo')
  const router = useRouter()  

  function logout()
  {
    localStorage.removeItem("msc")
    router.push({ name: 'login'})
  }
</script>

<style lang="css" src="./assets/css/bootstrap.min.css"></style>
<style lang="css" src="./assets/css/myshortcut.css"></style>
